<template>
  <div class="spinner-border spinner-theme_default" role="status">
    <span class="sr-only">
      Loading...
    </span>
  </div>
</template>

<script>
export default {
  name: 'PageHeaderLoader'
}
</script>
